import store from '@/store'
import sweetalertUtil from '@/utils/sweetalertUtil'
import i18n from '@/translations'
import { isCurrentTokenExpired } from '@/utils/tokenUtil'

const verifyTokenGuardWithoutPermission = async (to, from, next) => {
  const loggedUser = store.getters['auth/getLoggedUser']
  const isExpired = isCurrentTokenExpired(store)

  if (!loggedUser) {
    try {
      const { data, error } = await store.dispatch('auth/getSession')
      if (!error && data?.user) {
        const expires_in = data.expires_in || data.data?.expires_in
        const redirectUrl = data.user.route_name_redirect?.domain

        if (redirectUrl) {
          window.location.href = `${redirectUrl}/verify-token/authenticate/${expires_in}`
          return
        }
      }
    } catch (error) {
      console.error(error)
    }
    
    store.dispatch('auth/logoutLocalOnly')
    sessionStorage.setItem('justLoggedOut', '1')
    next({ name: 'landing-page' })
    return
  }

  if (isExpired) {
    const { error } = await store.dispatch('auth/refreshToken')
    if (error) {
      store.dispatch('auth/logout')
      next({ name: 'landing-page' })
      return
    }
  }

  if (isCurrentTokenExpired(store)) {
    store.dispatch('auth/logout')
    next({ name: 'landing-page' })
    return
  }

  next()
}

export default verifyTokenGuardWithoutPermission
